import React, {useEffect} from "react";
import {useAppDispatch, useAppSelector} from "../../utils/Hooks";
import {useLocation, useParams, useNavigate} from "react-router-dom";
import {RequestStatus} from "../../utils/Enums";
import {
    deleteCategoryType,
    getCurrentCategoryType,
    resetDeleteCategoryTypeStatus
} from "../../store/reducers/CategoryTypesSlice";
import Breadcrumbs from "../common/Breadcrumbs";
import {LoggedInView} from "../common/LoggedInView";
import {BreadcrumbLink} from "../../models/BreadcrumbLink";

interface DeleteCategoryTypeScreenProps {
}

export const DeleteCategoryTypeScreen: React.FC<DeleteCategoryTypeScreenProps> = () => {

    const dispatch = useAppDispatch();
    const location = useLocation();
    const navigate = useNavigate();

    const categoryTypesState = useAppSelector(state => state.categoryTypes);
    const requestStatus: RequestStatus = categoryTypesState.deleteCategoryTypeStatus;

    const {id} = useParams();

    const breadcrumbLinks: BreadcrumbLink[] = [
        {text: 'Grupi tüübid', url: '/category-types'},
        {text: 'Kustuta tüüp', url: '/category-types/delete/'},
    ];

    useEffect(() => {
        dispatch(resetDeleteCategoryTypeStatus());
    }, [location]);

    const handleConfirm = () => {
        dispatch(deleteCategoryType({id}));
    };

    const handleCancel = () => {
        navigate(-1);
    };

    useEffect(() => {
        dispatch(getCurrentCategoryType({id}));
    }, [id]);

    const showSuccess = () => {
        return (
            <div className="message msg-ok">
                <div>
                    <h2>Grupi tüüp kustutatud</h2>
                </div>
            </div>
        )
    };

    const showConfirm = () => {
        return (
            <div className="message" style={{textAlign: 'center'}}>
                <div>
                    <h2>
                        Oled kindel, et soovid grupi
                        tüübi <em>{categoryTypesState?.currentCategoryType?.name ?? ''}</em> kustutada?
                    </h2>
                    <p>
                        <form method="post" id="delete_form" name="delete_form">
                            <input type="hidden" name="yes" value="yes"/>
                            <button type="button" onClick={handleConfirm}>
                          <span>
                            <strong>Jah</strong>
                          </span>
                            </button>
                            <button type="button" onClick={handleCancel}>
                                Ei
                            </button>
                        </form>
                    </p>
                </div>
            </div>
        );
    }

    return (
        <LoggedInView fullWidth={false}>
            <Breadcrumbs links={breadcrumbLinks}/>
            {requestStatus === RequestStatus.Success && showSuccess()}
            {requestStatus !== RequestStatus.Success && showConfirm()}
        </LoggedInView>
    );

}